import { createReducer } from 'deox'
import {
  addActiveListDrops,
  addCompletedListDrops,
  addUpcomingListDrops,
  setStatusLoading,
  addMostTractionListDrops,
  addRecentlyLaunchedListDrops,
  addClosingSoonListDrops,
  addMostFundedListDrops,
  addAllListDrops,
} from './actions'

import { IDropListProps } from '../../types/reducerTypes'

export const initialState: IDropListProps = {
  all: [],
  active: [],
  upcoming: [],
  completed: [],
  mostTraction: [],
  recentlyLaunched: [],
  closingSoon: [],
  mostFunded: [],
  loading: false,
  total: 0,
}

const accessReducer = createReducer(initialState, (handleAction) => {
  return [
    handleAction(addAllListDrops, (state, { payload }) => ({
      ...state,
      all: [...payload.drops],
      total: payload.total,
    })),
    handleAction(addUpcomingListDrops, (state, { payload }) => ({
      ...state,
      upcoming: [...payload.drops],
    })),
    handleAction(addActiveListDrops, (state, { payload }) => ({
      ...state,
      active: [...payload.drops],
    })),
    handleAction(addCompletedListDrops, (state, { payload }) => ({
      ...state,
      completed: [...payload.drops],
    })),
    handleAction(addMostTractionListDrops, (state, { payload }) => ({
      ...state,
      mostTraction: [...payload.drops],
    })),
    handleAction(addRecentlyLaunchedListDrops, (state, { payload }) => ({
      ...state,
      recentlyLaunched: [...payload.drops],
    })),
    handleAction(addClosingSoonListDrops, (state, { payload }) => ({
      ...state,
      closingSoon: [...payload.drops],
    })),
    handleAction(addMostFundedListDrops, (state, { payload }) => ({
      ...state,
      mostFunded: [...payload.drops],
    })),
    handleAction(setStatusLoading, (state, { payload }) => ({
      ...state,
      loading: payload.loading,
    })),
  ]
})

export default accessReducer
